export const TRADE_DISCOUNT_PERCENT = 20;
export const TRADE_PRICE_MULTIPLIER = 0.8;
